import type { FormEventHandler, ReactNode } from 'react';
import React from 'react';

type FormProps = {
  children: ReactNode;
  onSubmit: FormEventHandler<HTMLFormElement>;
};

export const Form = ({ children, onSubmit }: FormProps) => {
  return (
    <form style={{ display: 'contents' }} onSubmit={onSubmit}>
      {children}
    </form>
  );
};
